import { BasicFilter, Filter, FilterMetadata } from "~/modules/filters/types";

// // // //

export function getDefaultNewFilter(filterMetadata: FilterMetadata[]): Filter {
    const filterMeta = filterMetadata[0];

    const field = filterMeta?.field;
    const operator = filterMeta?.defaultOperator;
    const defaultValue = filterMeta?.defaultValue;

    const value = ["null", "undefined"].includes(typeof defaultValue)
        ? undefined
        : defaultValue;

    return {
        field,
        operator,
        value,
    } as BasicFilter;
}
